import { useRecoilValue } from 'recoil';
import { sidebarState } from 'domains/viewer/Viewer/Sidebar';
import { HANGING_PROTOCOL_SIDEBAR_ID } from 'domains/viewer/Viewer/StudiesBar/HangingProtocols/HangingProtocolWidget';

/** Returns true when the HP edit/create sidebar is open. Works across windows via broadcast-synced sidebar state. */
export function useIsHPEditMode(): boolean {
  const sidebar = useRecoilValue(sidebarState);
  return sidebar.isOpen && sidebar.activeSidebarId === HANGING_PROTOCOL_SIDEBAR_ID;
}
